import { ChangeEvent, FC } from 'react';

import Select, { ActionMeta, SingleValue } from 'react-select';
import RangeSlider, { MarkType } from 'components/Common/RangeSlider';
import Switcher from 'components/Common/Switcher';
import Title from 'components/Common/Title';

interface SelectType {
    value: string;
    label: string;
}

interface InputBaseType {
    name: string;
    value: string;
    onChangeInput?: (e: ChangeEvent<HTMLInputElement>) => void;
    title?: string;
    text?: string;
    type?: string;
    onSelectChange?: (
        newValue: SingleValue<SelectType>,
        actionMeta?: ActionMeta<SelectType>,
    ) => void;
    leftText?: string;
    rightText?: string;
    id?: string;
    uniqueName?: string;
    onChange?: () => void;
    min?: string;
    max?: string;
    step?: string;
    marks?: MarkType[];
    valueLabelFormat?: () => void;
    options?: SelectType[];
    error?: Error;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
}

const InputBase: FC<InputBaseType> = (props) => {
    const {
        name,
        title,
        type,
        leftText = '',
        rightText = '',
        id = '',
        uniqueName = '',
        min = '',
        max = '',
        step = '',
        marks = [],
        options = [],
        value,
        error,
        onChange = () => {},
        valueLabelFormat = () => {},
        onChangeInput = () => {},
        disabled = false,
        ...args
    } = props;

    const showInput = type !== 'switcher' && type !== 'slider' && type !== 'select';
    return (
        <>
            {title && <Title title={title} />}
            {type === 'switcher' && (
                <Switcher
                    value={value}
                    leftText={leftText}
                    rightText={rightText}
                    id={id}
                    uniqueName={uniqueName}
                    onChange={onChange}
                    {...args}
                />
            )}
            {type === 'slider' && (
                <RangeSlider
                    min={min}
                    max={max}
                    step={step}
                    marks={marks}
                    valueLabelFormat={valueLabelFormat}
                    onChange={onChange}
                    value={value}
                />
            )}
            {type === 'select' && (
                <Select
                    value={options?.find((state: { value: string }) => state.value === value)}
                    onChange={onChange}
                    {...args}
                />
            )}
            {showInput && (
                <input
                    type={type}
                    name={name}
                    onChange={onChangeInput}
                    disabled={disabled}
                    value={value}
                    {...args}
                />
            )}
            {error && <div className="error-message">{error?.message}</div>}
        </>
    );
};

export default InputBase;
